module.exports = __webpack_public_path__ + "static/img/floorAreaSvgReference.2e6cb93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/floorAreaSvgReference.jpg
// module id = u4qo
// module chunks = 1 2